<template>
    <div class="padding">
        <div class="flex align-center justify-between margin-bottom">
            <div class="flex align-center">
                <el-input
                    v-model="searchName"
                    placeholder="请输入企业名称/手机号"
                    style="width: 350px"
                ></el-input>
                <el-button class="margin-left-sm" type="primary" @click="search"
                >搜索
                </el-button
                >
            </div>
            <el-link
                v-if="user.user_role === 1"
                :href="udhost + '/api/Operation/self_registration_export?name=' + searchName"
                :underline="false"
                target="_blank"
            >
                <el-button
                    class="margin-left-sm"
                    icon="el-icon-s-order"
                    type="warning"
                    @click="search"
                >信息导出
                </el-button
                >
            </el-link
            >
        </div>

        <el-table
            :data="tableData"
            alig="center"
            border
            header-row-class-name="table-header"
            row-class-name="table-row"
            style="width: 100%"
        >
            <el-table-column label="序号" type="index" width="80"></el-table-column>
            <el-table-column label="帐号" prop="user_name"></el-table-column>
            <el-table-column label="手机号" prop="tel_number"></el-table-column>
            <el-table-column label="操作" prop="state_text" width="150px" v-if="user.user_role === 1">
                <template slot-scope="scope">
                    <el-button
                        class="font-size-sm"
                        type="text"
                        @click="deleteItem(scope.row.id)">
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            v-if="tableData.length > 0"
            :current-page.sync="page"
            :page-size="limit"
            :total="total"
            background
            class="page-all"
            layout="prev, pager, next, jumper"
            @current-change="getList"
        >
        </el-pagination>
    </div>
</template>

<script>
import {UDHOST} from '@/config/index'
import {delRegistration, selfRegistration} from "@/api/admin";

export default {
    name: "register",
    data() {
        return {
            searchName: '',
            page: 1,
            limit: 10,
            total: 0,
            tableData: [],
        }
    },
    created() {
        this.getList()
    },
    computed: {
        udhost() {
            return UDHOST
        },
        user() {
            return this.$store.state.user
        },
    },
    components: {},
    methods: {
        //  搜索
        search() {
            this.page = 1
            this.getList()
        },
        //  获取列表
        async getList() {
            let _data = await selfRegistration(this.searchName, this.page, this.limit)
            this.tableData = _data.data.data
            this.total = _data.data.total
        },
        deleteItem(id) {
            this.$confirm("确定要删除此帐号吗", "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.delQuestion(id)
            })
        },
        async delQuestion(id) {
            let _data = await delRegistration(id)
            if (_data.status === 200) {
                this.getList()
                this.$message.success(_data.msg)
            }
        },

    },
    filters: {},
    watch: {},
}
</script>

<style lang="scss" scoped>
</style>
